import {createSlice} from "@reduxjs/toolkit";

const exportSlice = createSlice({
  name: "exportSlice",
  initialState: {
    loading: {
      ortho: false,
      hillshade: false,
      surfaceModel: false,
      measurement: false,
      smartTracking: false,
      excel: false
    },
    message: {
      ortho: null,
      hillshade: null,
      surfaceModel: null,
      measurement: null,
      smartTracking: null,
      excel: null
    }
  },
  reducers: {
    saveOrthoExportAction(){},
    saveTerrainExportAction(){},
    saveMeasurementExportAction(){},
    saveDSMExportAction(){},
    saveExportSmartTrackingAction(){},
    saveExportExcelAction(){},
    setExportLoadingAction(state, action) {
      const { type, loading, message } = action.payload;
      if (state.loading.hasOwnProperty(type)) {
        state.loading[type] = loading;
        state.message[type] = message || null;
      }
    }
  }
})

export const {
  saveTerrainExportAction, 
  saveMeasurementExportAction, 
  saveOrthoExportAction, 
  saveDSMExportAction, 
  saveExportExcelAction, 
  saveExportSmartTrackingAction,
  setExportLoadingAction
} = exportSlice.actions

export default exportSlice.reducer